import { DeliveryDateEffects } from './delivery-date.effect';
import { DeliverySlotsEffects } from './delivery-slots.effect';
import { DeliveryZonesEffects } from './delivery-zones.effect';

export const effects: any[] = [DeliverySlotsEffects, DeliveryZonesEffects, DeliveryDateEffects];
